<template>
  <div>
    <content-panel class="panel-tabs">
      <el-tabs v-model="activeName" @tab-click="handleClick" class="tabs">
        <el-tab-pane label="清单数据" name="InventoryData"> </el-tab-pane>
        <el-tab-pane label="商品数据" name="GoodsData"> </el-tab-pane>
        <el-tab-pane label="店铺数据" name="StoreData"> </el-tab-pane>
        <el-tab-pane label="明细数据" name="DetailsData"> </el-tab-pane>
      </el-tabs>
      <component :is="activeComponent" @switchTab="switchTab" @goDetails="goDetails" :ref="activeComponent"></component>
    </content-panel>
  </div>
</template>

<script>
import InventoryData from './inventory-data/InventoryData';
import GoodsData from './goods-data/GoodsData';
import StoreData from './store-data/StoreData';
import DetailsData from './details-data/DetailsData';
import pagePathMixin from '@/utils/page-path-mixin';
export default {
  name: 'NewproductProcessData1',
  mixins: [pagePathMixin],
  components: { InventoryData, GoodsData, StoreData, DetailsData },
  data() {
    return {
      activeName: 'InventoryData',
    };
  },
  computed: {
    activeComponent() {
      return this.activeName;
    },
  },
  mounted() {
    let query = this.$route.query
    if(query.activeName) {
      this.activeName = query.activeName
    }
  },
  methods: {
    handleClick() {},
    switchTab(data) {
      this.activeName = data.tabName
      this.$nextTick(_=>{
        this.$refs[data.tabName].searchForm.listNo = data.listNo
      })
      
    },
    goDetails(data) {
      this.activeName = 'DetailsData'
      this.$nextTick(_=>{
        this.$refs['DetailsData'].searchForm.name = data.name
        this.$refs['DetailsData'].searchForm.storeCode = data.storeCode ? [data.storeCode] : []
      })
    }
  },
};
</script>

<style lang="stylus" scoped>
.panel-tabs
  >>> .main-area
    padding-top 0
.tabs
  >>> .el-tabs__header
    margin-bottom 5px
  >>> .el-badge
        left -4px
  >>> .el-badge__content
        background-color #f56c6c
</style>
